module.exports = __webpack_public_path__ + "img/bhs_scholarship_portal4.3ac0ced3.png";